import { Component, OnDestroy, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription, lastValueFrom } from "rxjs";
import { CookieKeys, URLParamKeys } from "src/domain/constants";
import themes from "src/domain/themes";
import { AppService } from "src/services/app.service";
import { BrandService } from "src/services/brand.service";
import { ChannelRequestService } from "src/services/channel-request.service";
import { CookieService } from "src/services/cookie.service";
import { ThemeService } from "src/services/theme.service";
import { URLService } from "src/services/url.service";
import { TrackingService } from "src/services/tracking.service";

@Component({
  selector: "vw-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  error = false;
  applicationInitiated = false;

  private titleSubscription?: Subscription;
  private favIcon = document.querySelector<HTMLLinkElement>("link#favIcon");

  constructor(
    public brandService: BrandService,
    public themeService: ThemeService,
    public channelRequestService: ChannelRequestService,
    public appService: AppService,
    private title: Title,
    private translateService: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlService: URLService,
    private cookieService: CookieService,
    private trackingService: TrackingService,
  ) {}

  ngOnInit(): void {
    const brandFromURL = this.brandService.getBrandFromURL();
    const brandValid = this.brandService.validateBrand(brandFromURL);
    if (brandValid) {
      const translateObservable: Observable<string> = this.translateService.get(
        `headTitles.${brandFromURL}`,
      );
      this.titleSubscription = translateObservable.subscribe((text) => {
        this.title.setTitle(text);
      });
      this.router.events.forEach(async (item) => {
        if (item instanceof NavigationEnd) {
          const titleString =
            this.title.getTitle() || (await lastValueFrom(translateObservable));
          this.trackingService.trackPageChange(location.href, titleString);
        }
      });
      if (this.favIcon) {
        this.favIcon.href = `./assets/img/favicons/favicon_${brandFromURL}.ico`;
      }

      this.themeService.setBrand(brandFromURL);
      this.appService
        .initiateApplication(
          brandFromURL,
          this.urlService.getQueryParamByKey(URLParamKeys.dealerNumber),
          this.urlService.getQueryParamByKey(URLParamKeys.regNr),
        )
        .then(() => {
          this.themeService.setBrand(brandFromURL);
          this.applicationInitiated = true;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParamsHandling: "preserve",
            preserveFragment: true,
          });
        });
    } else {
      this.router
        .navigate([`/${themes[0]}`])
        .then(() => window.location.reload());
    }
  }

  ngOnDestroy(): void {
    this.titleSubscription?.unsubscribe();
  }

  tryAgain(): void {
    if (this.brandService.brand?.urlShort) {
      this.cookieService.deleteCookie(
        CookieKeys.channelRequestId,
        `/${this.brandService.brand.urlShort}`,
      );
    }

    location.reload();
  }
}
